"use client";

import { Cta } from "./cta";
import { MaskedHeadline, Reveal } from "./motion-primitives";
import { useQuote } from "./quote-context";

export function BrandAssist() {
  const { goToQuote } = useQuote();
  return (
    <section className="relative overflow-hidden bg-ink py-24 sm:py-32">
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.16]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(105deg, var(--brass) 0 1px, transparent 1px 26px)",
        }}
      />
      <div className="relative mx-auto max-w-[1400px] px-5">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_1fr] lg:items-end">
          <h2 className="font-display text-[clamp(2.2rem,6vw,5rem)] leading-[0.94] font-bold text-softwhite">
            <MaskedHeadline lines={["Looking for a particular", "product or brand?"]} />
          </h2>
          <div>
            <Reveal delay={0.1}>
              <p className="max-w-md text-base leading-relaxed text-softwhite/70">
                Tell us what you have in mind. Mills Engraving will help explore the
                available options and confirm what may work for your project.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-8">
                <Cta
                  onClick={() =>
                    goToQuote({ notes: "I'm asking about a specific product or brand: " })
                  }
                >
                  Ask About a Product
                </Cta>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}